import { makeStyles } from 'tss-react/mui';

export const useTruncatedTextFieldStyles = makeStyles()({
  wrapper: {
    minWidth: 0,
  },
  input: {
    textOverflow: 'ellipsis',
  },
  tooltipContent: {
    display: 'block',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
});
